import { useParams } from "react-router-dom";
import HiddenPage from "./hiddenpage";
import { hiddenpagedata } from "../data/hiddenpage";

const HiddenPageWrapper = () => {
  const { name } = useParams();
  const page = hiddenpagedata.find((n) => n.name === name);

  if (!page) return <h2>Page Not Found</h2>;
  return (
    <>
      <HiddenPage {...page} />
    </>
  );
};

export default HiddenPageWrapper;
